import * as React from 'react';
import { Accordion } from '@grandvisionhq/common';
import { Container, Heading } from '@grandvisionhq/elements';

const Faq = ({ name , title , ids , children  })=>{
    const [activeId, setActiveId] = React.useState('');
    const handleTitleClick = React.useCallback(()=>{
        history.replaceState(null, '', `#${name}`);
    }, [
        name
    ]);
    // Handle hash from url on mount
    React.useEffect(()=>{
        const id = window.location.hash.replace(/^#/, '');
        const hasItem = ids.find((idx)=>idx === id
        ) || name === id;
        hasItem && setActiveId(id);
    }, []);
    React.useEffect(()=>{
        if (activeId) {
            // Push onto callback queue so it runs after the DOM is updated
            setTimeout(()=>{
                const node = document.getElementById(activeId);
                if (node) {
                    const headerOffset = 200;
                    const { top  } = node.getBoundingClientRect();
                    const to = Math.round(top + window.scrollY) - headerOffset;
                    if (to > headerOffset) {
                        window.scrollTo(0, to);
                    }
                }
                // If the active hash is not the title, focus the related te control element
                if (activeId !== name) {
                    const ctrlNode = document.getElementById(`${activeId}-control`);
                    ctrlNode && ctrlNode.focus();
                }
            }, 250);
        }
    }, [
        activeId
    ]);
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("button", {
        className: "faq-title-wrapper",
        onClick: handleTitleClick,
        "aria-label": title
    }, /*#__PURE__*/ React.createElement(Heading, {
        id: name,
        component: "h2",
        variant: "medium"
    }, title)), /*#__PURE__*/ React.createElement(Accordion, {
        className: "faq"
    }, React.Children.map(children, (child)=>/*#__PURE__*/ React.isValidElement(child) && /*#__PURE__*/ React.cloneElement(child, {
            activeId
        })
    )));
};
var Faq$1 = Faq;

export { Faq, Faq$1 as default };
//# sourceMappingURL=Faq.js.map
